<app-collection [compact]="true" [fullBordered]="false" *ngIf="shownTranscriptItems">
    <app-member-transcript-card *ngFor="let item of shownTranscriptItems" [item]="item" [teamId]="teamMember.team.teamID"></app-member-transcript-card>
</app-collection>
<div class="display-flex justify-content-center margin-top-1">
    <button class="button button--primary" type="button" (click)="loadMore()" *ngIf="nextPageEnabled">{{ 'BUTTON_LOADMORE' | translate }}</button>
</div>
